import React from 'react';
import { Typography } from '@mui/material';

import Tabs from '../components/common/Tab/Tabs';
import EnlightSyncCheckPanel from '../components/EnlightSyncCheck/EnlightSyncCheck';
import { useUserProfile, isAppAdminAuthority } from '../context/UserProfileContext';

const EnlightSyncCheckPage: React.FC = () => {
  const { profile } = useUserProfile();
  const canView = isAppAdminAuthority(profile?.authority);

  if (!canView) {
    return (
      <div>
        <Tabs />
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <Typography variant="h6">本機能はアプリ管理者以上のみ操作できます</Typography>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Tabs />
      <EnlightSyncCheckPanel />
    </div>
  );
};

export default EnlightSyncCheckPage;
